module.exports = __webpack_public_path__ + "static/media/BTCB-ETH.7d340b12.svg";